import { Injectable } from '@angular/core';
import * as moment from 'moment';


@Injectable()
export class UtilityService {

  constructor() { }

  diffYMDHMS(date1, date2) {

    let years = date1.diff(date2, 'year');
    date2.add(years, 'years');

    let months = date1.diff(date2, 'months');
    date2.add(months, 'months');

    let days = date1.diff(date2, 'days');
    date2.add(days, 'days');

    let hours = date1.diff(date2, 'hours');
    date2.add(hours, 'hours');

    let minutes = date1.diff(date2, 'minutes');
    date2.add(minutes, 'minutes');

    let seconds = date1.diff(date2, 'seconds');

    years = years > 0 ? years : 0;
    months = months > 0 ? months : 0;
    days = days > 0 ? days : 0;
    hours = hours > 0 ? hours : 0;
    minutes = minutes > 0 ? minutes : 0;
    seconds = seconds > 0 ? seconds : 0;

    let timeDiff = ""
    if (years) timeDiff = years + " YEARS"
    else if (months) timeDiff = months + " MONTHS"
    else if(days) timeDiff = days + " DAYS"
    else if (hours) timeDiff = hours + " HOURS"
    else timeDiff = minutes + " MINUTES"
    
    return { years, months, days, hours, minutes, seconds, timeDiff};
  }
  
  counterFromCurrentDate(date)
  {
    return this.diffYMDHMS(date, moment(new Date()));
  }
}
